/* src/app/admin/admin.component.css */
body {
  background-color: #f2f2f2;
  color: #000000;
}
.input-field label {
  font-size: 11px;
  padding-left: 5px;
  color: black !important;
  font-weight: normal;
}
.input-field input {
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
  border-bottom-color: #fff !important;
  color: #fff;
  height: 36px;
  background: transparent;
}
.searchbox {
  width: 80% !important;
  height: 34px;
}
.exUpload {
  background-color: #30a740;
  border-radius: 30px;
}
.exUploadCancel {
  background-color: #d9534f;
  border-radius: 30px;
}
table {
  border-spacing: 1px;
  border-collapse: collapse;
  table-layout: inherit;
}
table th,
table td {
  padding: 1px;
}
.search_modified {
  margin: 4px 4px 0 -37px;
  background-color: #028ba3 !important;
  padding: 10px 10px 8px 10px;
  color: #ffffff;
  margin-top: 60px;
}
.input-ErrorField {
  font-size: 12px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
  border-bottom-color: #fff !important;
  color: #cc0000;
  height: 36px;
  background: transparent;
  position: relative;
}
.container-hide {
  visibility: hidden;
}
.container-unhide {
  visibility: visible;
}
.internal-hide {
  display: none;
}
.internal-unhide {
  display: visible;
}
[hidden] {
  display: none !important;
}
.searchbox {
  width: 400px !important;
  margin-bottom: 10px !important;
  margin-left: 5px !important;
  height: 33px !important;
}
.header_bg {
  background: url(/assets/images/ots_bg.png) no-repeat center top;
  text-align: center;
  background-size: cover;
}
.logo {
  text-align: left;
  color: #fff;
  padding: 12px 0px 0px 25px;
}
.user_main {
  float: right;
  text-align: right;
  color: white;
  border-left: solid 1px rgba(0, 0, 0, 0.2);
  padding: 30px 30px 30px 0px;
}
.user_main p {
  float: right;
  padding-right: 10px;
}
.user_icon {
  float: right;
  background-color: #008ad0;
  padding: 8px;
  border-radius: 30px;
  font-size: 20px;
}
.blw_headermain {
  text-align: left;
  color: #fff;
  padding: 10px 15px 0px 15px;
}
.blw_headermain img {
  float: left;
  padding-right: 10px;
}
.blw_headermain p {
  color: #2a2a2a;
  opacity: 0.8;
}
.round_table {
  border-radius: 20px;
  width: 100%;
  overflow-x: scroll;
}
.round_table {
  border-collapse: separate;
  border-spacing: 0;
}
.round_table tr {
  border: 1px solid #d6d6d6;
  border-radius: 20px;
  -moz-border-radius: 20px;
  -o-border-radius: 20px;
  -webkit-border-radius: 10px;
}
.round_table td {
  border-bottom: 1px solid #d6d6d6;
  background-color: #ffffff;
}
.round_table tbody tr th:nth-child(1) {
  padding-left: 20px;
}
.round_table tbody tr td:nth-child(1) {
  padding-left: 20px;
}
.round_table tbody tr td:nth-child(8) {
  padding-right: 20px;
  width: 100px;
}
.internal_main {
  padding: 0px;
}
.checkbox td {
  width: 20px;
}
.order_buttonicon {
  border-radius: 30px;
  background: #009f16 !important;
  text-transform: capitalize;
  box-shadow: none;
  padding: 5px 18px 0px 11px;
}
.order_btncancel {
  border-radius: 30px;
  background: #d9534f !important;
  text-transform: capitalize;
  box-shadow: none;
  padding: 5px 18px 0px 11px;
  margin-left: 5px;
}
.tab-content > .active {
  display: block;
}
.userbtn_main {
  position: absolute;
  right: 0px;
}
.add_internaluserbtn {
  background-color: #4eb700 !important;
  padding: 22px 10px 10px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
  height: auto !important;
  line-height: 0px;
  margin-right: 5px;
}
.add_internaluserbtn span {
  font-size: 16px;
}
.userlog_btn {
  background-color: #00adcc !important;
  padding: 5px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
  height: auto !important;
  line-height: 0px;
  margin-right: 5px;
}
.transaction_btn {
  background-color: #028ba3 !important;
  padding: 5px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
  height: auto !important;
  line-height: 0px;
  margin-right: 5px;
}
.transaction_btn img {
  float: none;
  padding: 0px;
}
.external_userlog_btn {
  background-color: #00adcc !important;
  padding: 5px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
  height: auto !important;
  line-height: 0px;
}
.external_add_internaluserbtn {
  background-color: #4eb700 !important;
  padding: 22px 10px 10px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
  height: auto !important;
  line-height: 0px;
}
.bulk_upload {
  background-color: #009f16 !important;
  padding: 22px 10px 10px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
  height: auto !important;
  line-height: 0px;
}
.external_userlog_btn img {
  float: none;
  padding: 0px;
}
.userlog_btn img {
  float: none;
  padding: 0px;
}
.round_table tbody tr th {
  border-bottom: 1px solid #d6d6d6;
}
#exTab1 .tab-content {
  color: #000000;
  padding: 0px;
  border-radius: 10px;
}
#exTab1 .nav-pills > li > a {
  border-radius: 0;
}
td,
th {
  white-space: nowrap;
  padding: 10px 5px;
  display: table-cell;
  text-align: left;
  vertical-align: middle;
  border-radius: 2px;
}
.nav_main {
  float: left;
  background-color: #ffffff;
  border-radius: 30px;
  border: 1px solid #cccccc;
  margin-bottom: 15px;
}
.nav-pills > li > a {
  border-radius: 30px !important;
  color: #000000;
  padding: 10px 36px;
}
.nav-pills > li > a:hover {
  background-color: #ffffff !important;
}
.nav-pills > li.active > a {
  color: #fff;
  background-color: #003992 !important;
}
.edit_icon {
  float: right;
  background-color: #009f16;
  color: #ffffff;
  padding: 10px;
  border-radius: 30px;
  font-weight: bold;
}
.form-group {
  padding: 0px !important;
  margin: 0px !important;
}
.input-field label {
  font-size: 11px;
  padding-left: 5px;
  color: #8bd0f3 !important;
  font-weight: normal;
}
.input-field input {
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
  border-bottom-color: #fff !important;
  color: #fff;
  padding-left: 5px;
  height: 36px;
  background: transparent;
}
.submit {
  padding: 10px;
  float: right;
}
.submit_btn {
  background-color: #009f16 !important;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
input:not([type]),
input[type=text],
input[type=password],
input[type=email],
input[type=url],
input[type=time],
input[type=date],
input[type=datetime],
input[type=datetime-local],
input[type=tel],
input[type=number],
input[type=search],
textarea.materialize-textarea {
  border: 1px solid #dedede;
  height: 31px;
  width: 100%;
  margin: 0px;
  padding: 0;
  font-size: 14px;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px;
}
input:focus {
  outline: none !important;
  border-color: #cccccc;
  box-shadow: none !important;
}
[type=checkbox]:not(:checked),
[type=checkbox]:checked {
  position: absolute;
  left: 0px;
  opacity: 1;
}
.checkbox input[type=checkbox],
.checkbox-inline input[type=checkbox],
.radio input[type=radio],
.radio-inline input[type=radio] {
  margin-left: 0px;
  font-size: 20px;
}
.dropdown-menu {
  right: 15px;
  left: auto;
  border-radius: 0px;
  padding: 0px;
  border: 1px solid #e4e4e4;
}
.dropdown-menu > li > a {
  display: block;
  padding: 15px 100px 15px 10px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  border-bottom: 1px solid #e0e0e0;
}
.dropdown-menu > li > a:hover {
  background-color: #008ad0;
  color: #ffffff;
}
.drop_downicon {
  color: #ffffff;
  position: 10px;
  right: 13px;
  top: -24px;
  font-size: 30px;
}
.addDataInTable table tr td {
  padding-right: 30px !important;
}
.addMandatory::before {
  content: "*";
  color: #cc0000 !important;
  font-size: 22px !important;
  line-height: 22px;
}
.addDataInTable table tr td:last-child {
  padding-right: 0 !important;
  text-align: right;
}
.widthChild85 {
  width: 85px !important;
}
.widthChild140 {
  width: 140px !important;
}
.widthChild150 {
  width: 150px !important;
}
.widthChild120 {
  width: 120px !important;
}
.widthChild200 {
  width: 200px !important;
}
.marginLeftMin15 {
  margin-left: -15px !important;
}
.marginLeftMin30 {
  margin-left: -30px !important;
}
.marginLeftMin33 {
  margin-left: -33px !important;
}
.marginLeftMin32 {
  margin-left: -32px !important;
}
.marginMinLeft45 {
  margin-left: -45px !important;
}
.marginLeft13 {
  margin-left: 13px !important;
}
@media (min-width: 300px) and (max-width: 600px) {
  .external_userlog_btn {
    background-color: #00adcc !important;
    padding: 5px 10px;
    border-radius: 20px;
    box-shadow: none !important;
    color: #ffffff !important;
    text-transform: capitalize;
    height: auto !important;
    line-height: 0px;
  }
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #505050;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #b30000;
  }
  .logo {
    text-align: left;
    color: #fff;
    padding: 25px 14px 0px 25px;
  }
  .user_main {
    float: right;
    text-align: right;
    color: white;
    border-left: solid 1px rgba(0, 0, 0, 0.2);
    padding: 15px 28px 7px 0px;
    margin-left: 0px;
  }
  .blw_headermain img {
    float: left;
    padding-bottom: 25px;
    padding-right: 10px;
  }
  .nav_main {
    float: left;
    background-color: #ffffff;
    border-radius: 30px;
    border: 1px solid #cccccc;
    margin-bottom: 100px;
  }
  .userbtn_main {
    margin-top: -90px;
    position: absolute;
    left: 0px;
  }
  .add_internaluserbtn {
    margin-top: 10px;
  }
  .userbtn_main img {
    float: right;
    padding: 4px 0px 0px 4px;
  }
  .userlog_btn {
    background-color: #00adcc !important;
    padding: 0px 10px !important;
    border-radius: 20px;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #ffffff !important;
    text-transform: capitalize;
    line-height: 36px;
  }
  .external_add_internaluserbtn {
    background-color: #4eb700 !important;
    padding: 8px 10px 10px 10px;
    border-radius: 20px;
    box-shadow: none !important;
    color: #ffffff !important;
    text-transform: capitalize;
    margin-top: 10px;
    height: auto !important;
    line-height: 0px;
  }
  .transaction_btn {
    background-color: #00adcc !important;
    padding: 0px 10px;
    border-radius: 20px;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #ffffff !important;
    text-transform: capitalize;
    line-height: 36px;
  }
  .searchbox {
    width: 90% !important;
  }
  .bulk_upload {
    background-color: #009f16 !important;
    padding: 8px 10px 10px 10px;
    border-radius: 20px;
    box-shadow: none !important;
    color: #ffffff !important;
    text-transform: capitalize;
    margin-top: 10px;
    height: auto !important;
  }
  .submit {
    padding: 10px;
    float: left;
  }
  .external_userlog_btn img {
    float: none;
    padding: 0px !important;
  }
  td {
    width: 80%;
  }
}
@media (min-width: 600px) and (max-width: 900px) {
  .transaction_btn {
    padding: 5px 10px;
    font-size: 12px;
  }
  .userlog_btn {
    padding: 5px 10px;
    font-size: 12px;
  }
  .ui-widget,
  .ui-widget * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow-x: scroll;
  }
  .userbtn_main {
    position: absolute;
    right: 0px;
  }
  .nav_main {
    margin-bottom: 15px;
  }
  .external_add_internaluserbtn {
    font-size: 12px;
  }
  .bulk_upload {
    font-size: 12px;
  }
  .add_internaluserbtn {
    margin-top: 0px;
  }
}
@media only screen and (max-width: 800px) {
  .no-more-tables table,
  \a0  .no-more-tables thead,
  \a0  .no-more-tables tbody,
  \a0  .no-more-tables th,
  \a0  .no-more-tables td,
  \a0  .no-more-tables tr {
    display: block;
  }
  .no-more-tables thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .no-more-tables tr {
    border: 1px solid #ccc;
  }
  .no-more-tables td {
    border: none;
    position: relative;
    border-bottom: 1px solid #eee;
    white-space: normal;
    text-align: left;
  }
  .no-more-tables td:before {
    text-align: left;
    font-weight: bold;
    white-space: nowrap;
    position: absolute;
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 0px;
  }
  .no-more-tables td:before {
    content: attr(data-title);
  }
}
.externalAddData {
  padding-left: 10px;
}
.externalAddData .addMandatory {
  position: relative;
}
.externalAddData .addMandatory::before {
  position: absolute;
  left: -10px;
}
.searchmain {
  margin: 0;
  text-align: right;
}
.custom-addagency {
  top: 8px;
}
.top7 {
  top: 7px !important;
  position: relative;
}
.ui-button-success {
  background-color: #28a745 !important;
  color: #fff !important;
  border-radius: 25px !important;
  border: none !important;
  box-shadow: none !important;
  padding: 11px 10px !important;
  font-weight: bold;
  transition: background 0.2s;
  margin-right: 10px !important;
  height: 2.875rem;
}
.ui-button-success:hover,
.ui-button-success:focus {
  background-color: #218838 !important;
  color: #fff !important;
}
.ui-button-danger {
  background-color: #dc3545 !important;
  color: #fff !important;
  border-radius: 30px !important;
  border: none !important;
  box-shadow: none !important;
  padding: 11px 10px !important;
  font-weight: bold;
  transition: background 0.2s;
  height: 2.875rem;
}
.ui-button-danger:hover,
.ui-button-danger:focus {
  background-color: #c82333 !important;
  color: #fff !important;
}
::ng-deep ul.p-dropdown-items,
::ng-deep ul.p-autocomplete-items {
  padding: 0;
  margin-bottom: 0;
}
/*# sourceMappingURL=admin.component.css.map */
